// Module Status Map
export const module_status_enabled_tab_map = {
    "Raw Resources": 0,
    "In Design Phase": 0,
    "In Outline Generation Queue": 0,
    "Outline Generation Failed": 0,
    "Outline Review": 1,
    "In Content Generation Queue": 1,
    "Content Generation Failed": 1,
    "Outline to Structure Failed": 1,
    "Content Review": 2,
    "Pre Processed Content": 2,
    "Post Processed Content": 2,
    "In Structure Generation Queue": 2,
    "Structure Generation Failed": 2,
    "Structure Review": 3,
    "Pre Processed Structure": 3,
    "Post Processed Structure": 3,
    "In Deliverables Generation Queue": 3,
    "Deliverables Generation Failed": 3,
    "Deliverables Review": 4,
    "Pre Processed Deliverables": 4,
    "Post Processed Deliverables": 4,
    "In Publishing Queue": 4,
    "Published": 5,
};

export const inBetweenStagesLoaderOptions = {
    "In Outline Generation Queue": "The outline is being generated. This can take anywhere between 5-10 minutes.",
    "In Content Generation Queue": "The content is being generated. This can take anywhere between 25-30 minutes.",
    "In Structure Generation Queue": "The structure is being generated. This can take anywhere between 5-10 minutes.",
    "In Deliverables Generation Queue": "The deliverables are being generated. This can take anywhere between 25-30 minutes.",
    "In Publishing Queue": "Module marked ready for publishing",
};

export const course_steps = [
    {
        lockedMessage: "",
    },
    {
        lockedMessage:
            "Please submit the resources and the instructions to unlock this step.",
    },
    {
        lockedMessage: "Please finish the outline review to unlock this step.",
    },
    {
        lockedMessage: "Please finish the content review to unlock this step.",
    },
    {
        lockedMessage: "Please finish the structure review to unlock this step.",
    },
];

// Fetch image as file
export async function fetchImageAsFile(imageUrl) {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], "qcreate_logo.png", { type: blob.type });
    return file;
}